const getGeneral = (state) => {
    return state.general
}  

export default{
    getGeneral
}